import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WAIVER_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_862989e7-44de-4ffc-8127-8a4973a4b2c2/artifacts/rsu5bq0l_Revised%20Waiver%20Adaptation%20MM%20revised.pdf";

export const IMAGES = {
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_862989e7-44de-4ffc-8127-8a4973a4b2c2/artifacts/7dj6o6ui_a228f807-4c03-4127-97a9-7a52e7046068.jpeg",
  heroLogo: "https://customer-assets-4nw71qhi.emergentagent.net/job_mickey-charters/artifacts/e54mpt9y_Mickey_Mouse_Charters_Logos-01%20%282%29.webp",
  water: "https://customer-assets-jai6qajn.emergentagent.net/job_862989e7-44de-4ffc-8127-8a4973a4b2c2/artifacts/fk63gmam_c45a95da-23a3-401f-b16f-4eb2b73d60b8.jpeg",
  boat: "https://customer-assets-jai6qajn.emergentagent.net/job_862989e7-44de-4ffc-8127-8a4973a4b2c2/artifacts/jo5xp58f_94a558ef-613e-4ae2-b399-3193885817f9.jpeg",
  cheers: "https://customer-assets-jai6qajn.emergentagent.net/job_862989e7-44de-4ffc-8127-8a4973a4b2c2/artifacts/mdw74sii_e0c9b6bb-58b4-48c2-9f71-5b4f96adff63.jpeg",
  stingray: "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export const api = axios.create({ baseURL: API });

export const adminApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${localStorage.getItem("mmc_token") || ""}` },
  });

export const partnerApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${localStorage.getItem("mmc_partner_token") || ""}` },
  });

export function parsePassengerCsv(text) {
  const rows = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const out = [];
  for (const row of rows) {
    const [name, age] = row.split(",").map((c) => c.trim().replace(/^"|"$/g, ""));
    if (!name || name.toLowerCase() === "name") continue;
    out.push({ name, age: age || "" });
  }
  return out;
}

export function downloadPassengerTemplate() {
  const csv = "Name,Age\nJohn Smith,34\nJane Smith,29\nBilly Smith,9\n";
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "passenger_template.csv";
  a.click();
  URL.revokeObjectURL(url);
}

export function prettyDate(iso) {
  return new Date(iso + "T12:00:00").toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
